import { useCallback } from "react";

import { useLaborAmendFlowsheetPersist } from "@/encounters/contexts/LaborAmendFlowsheetPersistContext";

/**
 * Returns a resolver that reads the encounter QR version id to stamp when the persist job runs.
 * Call inside queued `persist` jobs (at flush), not at enqueue time — the id is updated after Sign & Lock saves the encounter QR.
 */
export function useResolveLaborAmendEncounterParentVersionIdForStamp(): () => string | undefined {
  const { getEncounterQuestionnaireParentVersionIdForStamp, deferFlowsheetPersists } =
    useLaborAmendFlowsheetPersist();

  return useCallback(() => {
    if (!deferFlowsheetPersists) {
      return undefined;
    }
    return getEncounterQuestionnaireParentVersionIdForStamp();
  }, [deferFlowsheetPersists, getEncounterQuestionnaireParentVersionIdForStamp]);
}
